import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconArchive: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconArchive" {...props}>
    <svg height="100%" viewBox="0 0 18 18" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M13.5 0c.6213 0 1.125.50368 1.125 1.125V2.25H13.5V1.125h-9V2.25H3.375V1.125C3.375.503679 3.87868 0 4.5 0h9zm1.6875 3.375c.6213 0 1.125.50368 1.125 1.125v1.6875h-1.125V4.5H2.8125v1.6875h-1.125V4.5c0-.62132.50368-1.125 1.125-1.125h12.375zM1.125 8.4375v8.4375h15.75V8.4375H1.125zm15.75-1.125c.3164 0 .5801.10547.8086.31641.2109.22851.3164.49218.3164.80859v8.4375c0 .3164-.1055.5801-.3164.791-.2285.2285-.4922.334-.8086.334H1.125c-.316406 0-.580078-.1055-.791016-.334C.105469 17.4551 0 17.1914 0 16.875V8.4375c0-.31641.105469-.58008.333984-.80859.210938-.21094.47461-.31641.791016-.31641h15.75zM6.23864 11.25c-.33891 0-.61364.2518-.61364.5625s.27473.5625.61364.5625h5.52276c.3389 0 .6136-.2518.6136-.5625s-.2747-.5625-.6136-.5625H6.23864z"
        clipRule="evenodd"
      />
    </svg>
  </IconSVG>
)
